import React from 'react';
import shipImage from '../assets/images/cases/ship.svg';
import automationImage from '../assets/images/cases/automation.svg';
import truckerImage from '../assets/images/cases/trucker.svg';
import agrocoribePDF from '../assets/pdf/agrocoribe.pdf';
import cortesPDF from '../assets/pdf/cortes.pdf';
import quasarPDF from '../assets/pdf/quasar.pdf';

const CaseCard = ({ image, title, description, pdfLink }) => (
  <div className="relative rounded-[40px] border-2 border-[#783BFF] bg-white overflow-hidden">
    <div className="h-64">
      <img src={image} alt={title} className="w-full h-full object-cover" />
    </div>
    <div className="px-6 pb-6">
      <h3 className="text-[#783BFF] text-2xl font-semibold mb-4">{title}</h3>
      <p className="text-gray-600 text-lg mb-6">{description}</p>
      <div className="relative">
        <a href={pdfLink} target="_blank" rel="noopener noreferrer" className="block">
          <button className="bg-[#C6FF00] text-[#151342] font-semibold w-full py-3 rounded-full hover:bg-transparent hover:text-[#C6FF00] border-2 border-[#C6FF00] transition-all duration-300 transform hover:scale-105">
            Ver mais
          </button>
        </a>
      </div>
    </div>
  </div>
);

const CtaSection = ({ id }) => {
  return (
    <section className="bg-white py-12 px-4" id={id}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center mb-8">
          <span className="text-[#151342] text-4xl font-['ZenDots'] block">Conheça nossos</span>
          <span className="text-[#783BFF] text-4xl font-['ZenDots']">Cases de Sucesso</span>
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <CaseCard
            image={shipImage}
            title="Gestão de Romaneios em Exportação de Gengibre"
            description="Monitoramento preciso e integração inteligente para um fluxo logístico mais eficiente e sem desperdícios."
            pdfLink={agrocoribePDF}
          />
          
          <CaseCard
            image={automationImage}
            title="Automação de Análise de Mídias Para Competição"
            description="Análise em tempo real no Instagram, TikTok e YouTube, garantindo transparência e precisão na premiação."
            pdfLink={cortesPDF}
          />
          
          <CaseCard
            image={truckerImage}
            title="App Para Otimizar a Logística de Caminhões"
            description="Criamos um front-end responsivo e eficiente, facilitando o controle de frota, rotas e entregas com precisão."
            pdfLink={quasarPDF}
          />
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
